// Renders a platform-neutral ShortcutToken as a human-readable label (FR-011).
//
// macOS uses the glyph modifiers (⌘⌥⇧) with no separator, matching native app
// convention; every other platform uses "Ctrl+Alt+Shift" words. The token in
// controls.ts carries no platform assumption — this is the only place the
// distinction lives (research D-07; contract "macOS / other").

import { type ShortcutToken } from './controls.js';

export function isMacPlatform(): boolean {
  if (typeof navigator === 'undefined') return false;
  const descriptor = navigator.platform || navigator.userAgent || '';
  return /Mac|iPhone|iPad|iPod/i.test(descriptor);
}

export function formatShortcut(token: ShortcutToken, mac: boolean = isMacPlatform()): string {
  if (mac) {
    let out = '';
    if (token.mod) out += '⌘';
    if (token.alt) out += '⌥';
    if (token.shift) out += '⇧';
    return out + token.key;
  }
  const parts: string[] = [];
  if (token.mod) parts.push('Ctrl');
  if (token.alt) parts.push('Alt');
  if (token.shift) parts.push('Shift');
  parts.push(token.key);
  return parts.join('+');
}
